import levelingData from '../data/levelingData.json';
import { NATURES } from './gameData';

export function getExpPerCandy(nature, level = 30) {
    let baseExp = 25;
    if (level < 25) baseExp = 35;
    else if (level < 30) baseExp = 30;

    if (!nature) return baseExp;
    
    const n = NATURES[nature];
    if (n && n.up === 'Exp') return Math.round(baseExp * 1.2);
    if (n && n.down === 'Exp') return Math.round(baseExp / 1.2);
    
    return baseExp;
}

/**
 * Calculates the resource cost to upgrade a Pokémon.
 * @param {number} currentLevel - The Pokémon's current level.
 * @param {number} targetLevel - The desired level.
 * @param {string} natureName - The Pokémon's nature (affects candy yield).
 * @param {boolean} isSlowCurve - True if the Pokémon is a pseudo-legendary (1.5x EXP).
 * @param {number} evoCandies - Additional Candies needed for an evolution step.
 * @param {number} evoShards - Additional Dream Shards needed for an evolution step.
 * @returns {object} { expNeeded, candiesNeeded, shardsNeeded }
 */
export function calculateUpgradeCost(currentLevel, targetLevel, natureName, isSlowCurve = false, evoCandies = 0, evoShards = 0) {
    if (currentLevel >= targetLevel || targetLevel > 65) {
        return { expNeeded: 0, candiesNeeded: evoCandies, shardsNeeded: evoShards };
    }

    let expNeeded = 0;
    
    // 1. Calculate total EXP required purely for display
    for (let i = currentLevel; i < targetLevel; i++) {
        let levelExp = levelingData.expToNextLevel[i.toString()];
        if (isSlowCurve) {
            levelExp = Math.ceil(levelExp * 1.5);
        }
        expNeeded += levelExp;
    }

    // 2. Simulate feeding candies one by one to find exact candy and shard costs
    let candiesUsed = 0;
    let shardsUsed = 0;
    
    let simulatedLevel = currentLevel;
    let simulatedExp = 0;
    
    let currentLevelExpCap = levelingData.expToNextLevel[simulatedLevel.toString()];
    if (isSlowCurve) currentLevelExpCap = Math.ceil(currentLevelExpCap * 1.5);

    while (simulatedLevel < targetLevel) {
        candiesUsed++;
        
        const expYield = getExpPerCandy(natureName, simulatedLevel);
        const shardCost = levelingData.shardCostPerCandy[simulatedLevel.toString()];
        
        shardsUsed += shardCost;
        simulatedExp += expYield;

        // Handle level up(s) from this single candy
        while (simulatedExp >= currentLevelExpCap && simulatedLevel < targetLevel) {
            simulatedExp -= currentLevelExpCap;
            simulatedLevel++;
            
            if (simulatedLevel < targetLevel) {
                currentLevelExpCap = levelingData.expToNextLevel[simulatedLevel.toString()];
                if (isSlowCurve) currentLevelExpCap = Math.ceil(currentLevelExpCap * 1.5);
            }
        }
    }

    return { 
        expNeeded, 
        candiesNeeded: candiesUsed + evoCandies, 
        shardsNeeded: shardsUsed + evoShards 
    };
}